import { styled } from '@mui/material';

export const Tr = styled('tr')({});
